import axios from "axios";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import categories from "../data/categories.json";

import {
  Link,
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import {
  SET_CATEGORY,
  SET_TEST,
  SET_TRIAL,
} from "../Component/Redux/Feature/CategorySlice";
import {
  appAction,
  contactAction,
  emailAction,
} from "../Component/Redux/Feature/EmailSlice";
import {
  FormPageAction,
  setStartDateParam,
  userDetailAction,
} from "../Component/Redux/Feature/UrlSlice";
import { adminapiUrl } from "../Utils/constants";

const CategorySelect = () => {
  const [categories, setCategories] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { userDetails } = useSelector((state) => state.UrlData);

  const getCategories = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        adminapiUrl+"/read_allbranch_alltypes_allplans",
        // "https://admin-api.bodyprocoach.com/admin/read_allbranch_alltypes_allplans",
        {
          headers: {
            "Content-Type": "application/json",
          },
          mode: "no-cors",
        }
      );

      const data = res.data.data;
      setLoading(false);
      setCategories(data?.All_categories?.filter(cat => cat?.uid == 5 || cat?.uid == 10));
    } catch (err) {
      setLoading(false);
      setError(true);
    }
    // console.log("categories  => ", data);
  };

  useEffect(() => {
    if (searchParams.get("email"))
      dispatch(emailAction(searchParams.get("email")));

    if (searchParams.get("contact"))
      dispatch(contactAction(searchParams.get("contact")));

    if (searchParams.get("app")) dispatch(appAction(searchParams.get("app")));

    if (searchParams.get("trial"))
      dispatch(SET_TRIAL(searchParams.get("trial")));

    if (searchParams.get("email") && searchParams.get("contact"))
      dispatch(
        FormPageAction({
          email: searchParams.get("email"),
          phone: searchParams.get("contact"),
        })
      );
      if(searchParams.get("startdate")) {
        dispatch(setStartDateParam(searchParams.get("startdate")))
      }

    dispatch(
      userDetailAction({
        ...userDetails,
        startdate: searchParams.get("startdate"),
      })
    );

    dispatch(SET_TEST("456"));

    getCategories();
  }, []);

  function convertToModified(str) {
    return str.replace(/\s+/g, "-").replace(/(\s+|-{2,})/g, "-");
  }

  return (
    <div className="home-page">
      <div
        className="categoryContainer"
        // style={{
        //   left: "unset",
        //   width: "60%",
        //   marginInline: "auto",
        //   display: "flex",
        //   flexDirection: "column",
        //   alignItems: "center",
        // }}
      >
        <div style={{ marginBottom: "1rem" }}>
          <img src="/pilatesLogo.png"  width="250px"  style={{objectFit: "contain"}}></img>
        </div>
        <p>Please select category</p>

        <div
          // style={{
          //   width: "100%",
          //   display: "flex",
          //   flexDirection: "column",
          //   gap: "1rem",
          //   marginTop: "1rem",
          // }}
          className="categoryListContainer"
        >
          {loading && !categories && !error && (
            <div className="category">Loading...</div>
          )}
          {!loading && !categories && error && <div>Some error occurred</div>}
          {categories &&
            !loading &&
            categories.map((category) => {
              return (
                <div
                  onClick={() => {
                    dispatch(SET_CATEGORY(category?.slug));
                    // navigate(category.slug, {
                    //   params: {
                    //     email: searchParams.get("email"),
                    //     contact: searchParams.get("contact"),
                    //   },
                    // });
                    // );
                    navigate({
                      pathname: category?.slug,
                      // search: createSearchParams(searchParams).toString(),
                    });

                    // if (searchParams.get("trial")) {
                    //   navigate({
                    //     pathname: category.slug,
                    //     search: createSearchParams({
                    //       trial: searchParams.get("trial"),
                    //     }).toString(),
                    //   });
                    // } else
                    //   navigate({
                    //     pathname: category.slug,
                    //     // search: createSearchParams(searchParams).toString(),
                    //   });
                  }}
                  className="category"
                >
                  {/* <Link to={convertToModified(category.typename) + "/"}> */}
                  <p>{category?.typename}</p>

                  {/* </Link> */}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default CategorySelect;
